export default __webpack_public_path__ + "static/media/Child-Education-Planner-Calculator.3ca3e825.png";